import { Select } from '@src/components/ui/Select';
import { isFormValidationError } from '@src/utilities/form';
import { ICommonFormProps } from '../DynamicForm.types';

export function FormSelect(props: ICommonFormProps) {
    const { value, ...rest } = props.field!;
    const selectProps = {
        options: props.formProps?.selectOptions,
        filterOption: props.formProps?.filterOption,
        showSearch: props.formProps?.showserach,
        placeholder: props.formProps?.placeholder as string,
        ...(props.field?.value !== undefined && props.field?.value !== ''
            ? { value: props.field?.value }
            : null),
    };

    return (
        <Select
            {...({
                disabled: props.disabled || false,
                isRequired: Boolean(
                    typeof props.registerOptions?.required === 'object'
                        ? props.registerOptions?.required.value
                        : props.registerOptions?.required
                ),
                label: props.label,
                ...props.formProps,
                error: props.errors
                    ? isFormValidationError(props.errors.type)
                        ? props.errors?.message
                        : `${props.label} ${props.errors.type}`
                    : undefined,
                ...rest,
                ...selectProps,
            } as any)}
        />
    );
}